import { render, staticRenderFns } from "./TMPIframe.vue?vue&type=template&id=13e2fbca&scoped=true&"
import script from "./TMPIframe.vue?vue&type=script&lang=js&"
export * from "./TMPIframe.vue?vue&type=script&lang=js&"
import style0 from "./TMPIframe.vue?vue&type=style&index=0&id=13e2fbca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e2fbca",
  null
  
)

export default component.exports